import { Component, OnInit } from '@angular/core';
import * as firebase from 'firebase/app';
import 'firebase/auth';
@Component({
  selector: 'app-notpermited',
  templateUrl: './notpermited.component.html',
  styleUrls: ['./notpermited.component.scss'],
})
export class NotpermitedComponent implements OnInit {
  constructor() {}

  public firebase = firebase;

  ngOnInit() {}
}
